import { useContext } from "react";
import { Label } from "reactstrap";

//Common
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../common/DisplayData/DisplayData";
import { FormBackGround } from "../../common/Forms";

//App
import { TemplateEmailViewProps } from "../../../types/template";
import { TemplateEmailContext } from "./TemplateEmailContainer";
import useComponentGeneralStyles from "../../styles";


const TemplateEmailView = (props: TemplateEmailViewProps) => {
  const { onClose, editAction } = props;
  const templateContext = useContext(TemplateEmailContext);
  const generalStyles = useComponentGeneralStyles();
  const template = templateContext?.data;

  return (
    <>
      <FormBackGround>
        <FormHeader
          title={template?.templateName}
          chipLabel={template?.isActive ? "Active" : "Inactive"}
          onClose={onClose}
          editActionHandler={editAction}
          formClassName={"pb-0"}
        />
        <DisplayData
          text="Template Name"
          importedData={template?.templateName}
        />
        <DisplayData
          text="Template Description"
          importedData={template?.templateDescription}
        />
        <Label
          style={generalStyles.sectionHeader}
          className="border-bottom my-3 pb-2"
        >
          Email Template
        </Label>
        <DisplayData
          text="Email Name"
          importedData={template?.fromName}
        />
        <DisplayData
          text="Email Address From"
          importedData={template?.fromEmailAddress}
        />
        <DisplayData
          text="Email Subject Line"
          importedData={template?.subject}
        />
        <Label
          style={generalStyles.sectionHeader}
          className="border-bottom my-3 pb-2"
        >
          WYSIWYG
        </Label>
        <div dangerouslySetInnerHTML={{__html: template?.htmlContent??""}}/>
      </FormBackGround>
    </>
  );
};

export default TemplateEmailView;
